var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateSaleOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_51",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3128",
    "data-name": "Rectangle 3128",
    width: 30.172,
    height: 37.355,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151",
    transform: "translate(9.336 6.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.34, -6.46)",
    filter: "url(#Ellipse_51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51-2",
    "data-name": "Ellipse 51",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9228",
    "data-name": "Group 9228",
    transform: "translate(27.665 24.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9227",
    "data-name": "Group 9227",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M7.069,2.357c0-.408,0-.793,0-1.178A1.352,1.352,0,0,1,7.129.8,1.138,1.138,0,0,1,8.373.011,1.152,1.152,0,0,1,9.419,1.17c0,.386,0,.772,0,1.173h7.063c0-.047.01-.1.01-.152,0-.344,0-.687,0-1.031A1.156,1.156,0,0,1,17.67,0a1.174,1.174,0,0,1,1.173,1.17c0,.386,0,.772,0,1.186h.2c1.092,0,2.184,0,3.276,0a3.348,3.348,0,0,1,1.922.527,3.506,3.506,0,0,1,1.62,2.457,4.471,4.471,0,0,1,.046.66q0,11.708-.005,23.416a3.485,3.485,0,0,1-1.772,3.114,3.192,3.192,0,0,1-1.38.415c-.329.032-.661.039-.992.039q-8.963,0-17.927,0a3.87,3.87,0,0,1-1.754-.335A3.468,3.468,0,0,1,.035,29.738,8.423,8.423,0,0,1,0,28.893Q0,17.405,0,5.918A3.337,3.337,0,0,1,.5,4.062a3.455,3.455,0,0,1,2.714-1.67c.293-.025.588-.033.882-.034.914,0,1.828,0,2.742,0h.229m0,2.351H6.916c-1.086,0-2.172,0-3.258,0a1.914,1.914,0,0,0-.434.065,1.117,1.117,0,0,0-.841.961c-.012.159-.031.318-.031.476q0,11.5,0,22.992c0,.068,0,.135,0,.2a1.171,1.171,0,0,0,.769,1.127,2.052,2.052,0,0,0,.686.1q9.175.008,18.349,0c.067,0,.135,0,.2-.005a1.184,1.184,0,0,0,1.144-.9,2.445,2.445,0,0,0,.055-.565q0-11.477,0-22.955c0-.1,0-.2-.007-.294a1.229,1.229,0,0,0-.523-.987,1.426,1.426,0,0,0-.84-.222q-1.6,0-3.2,0c-.046,0-.093.009-.146.015,0,.32,0,.627,0,.933a2.441,2.441,0,0,1-.038.439,1.158,1.158,0,0,1-1.163.959,1.137,1.137,0,0,1-1.11-1.014c-.041-.358-.027-.722-.038-1.083,0-.078,0-.156,0-.239H9.419c0,.156,0,.3,0,.448a6.905,6.905,0,0,1-.041.917,1.125,1.125,0,0,1-1.131.968,1.138,1.138,0,0,1-1.137-.964,2.723,2.723,0,0,1-.038-.457c-.006-.3,0-.6,0-.923",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M67.381,110.471c-1.9,0-3.8,0-5.7,0a1.3,1.3,0,0,1-.923-.3,1.134,1.134,0,0,1,.622-2,4.833,4.833,0,0,1,.585-.034q5.537,0,11.074,0a1.574,1.574,0,0,1,.714.138,1.108,1.108,0,0,1,.67,1.038,1.128,1.128,0,0,1-.832,1.073,2.048,2.048,0,0,1-.543.074q-2.833.008-5.666,0",
    transform: "translate(-54.422 -97.527)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M67.356,170.486c-1.895,0-3.79,0-5.684,0a1.28,1.28,0,0,1-.976-.349,1.134,1.134,0,0,1,.667-1.941,4.686,4.686,0,0,1,.6-.035q5.528,0,11.056,0a1.6,1.6,0,0,1,.732.141,1.105,1.105,0,0,1,.665,1.041,1.126,1.126,0,0,1-.837,1.069,2.1,2.1,0,0,1-.543.073q-2.842.008-5.684,0",
    transform: "translate(-54.42 -151.65)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M63.859,230.5c-.7,0-1.4,0-2.1,0a2.377,2.377,0,0,1-.508-.064,1.132,1.132,0,0,1,.13-2.226,5.319,5.319,0,0,1,.586-.035q2.016,0,4.031,0a1.587,1.587,0,0,1,.715.138,1.108,1.108,0,0,1,.672,1.038,1.128,1.128,0,0,1-.831,1.074,2.108,2.108,0,0,1-.543.074c-.718.008-1.436,0-2.154,0",
    transform: "translate(-54.455 -205.768)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4169",
    "data-name": "Rectangle 4169",
    width: 14,
    height: 15,
    transform: "translate(16.602 23.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M223.476,221.05h.244c1.037,0,2.074,0,3.111,0a2.4,2.4,0,0,1,.517.062,1.2,1.2,0,0,1,.926,1.15,1.221,1.221,0,0,1-1.019,1.115,3.452,3.452,0,0,1-.5.038c-1.006,0-2.012,0-3.017,0h-.259v.224c0,1.075,0,2.149,0,3.224a1.276,1.276,0,0,1-.515,1.109,1.155,1.155,0,0,1-1.815-.809,6.109,6.109,0,0,1-.037-.652c0-.95,0-1.9,0-2.849v-.246h-.237c-1.037,0-2.074,0-3.111,0a2.465,2.465,0,0,1-.536-.065,1.152,1.152,0,0,1,.131-2.265,5.4,5.4,0,0,1,.6-.036c.968,0,1.937,0,2.905,0h.251v-.232c0-1.081,0-2.162,0-3.243a1.26,1.26,0,0,1,.4-.992,1.1,1.1,0,0,1,1.184-.226,1.064,1.064,0,0,1,.738.951c.039.565.035,1.134.04,1.7.006.668,0,1.336,0,2.039",
    transform: "translate(-198.102 -190.836)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSaleOrder);
export default __webpack_public_path__ + "static/media/create-sale-order.3d95e45f7445990396698dd48ca563de.svg";
export { ForwardRef as ReactComponent };